import React from "react";
import { Image } from "@sitecore-jss/sitecore-jss-react";
var BrandItem = function (props) {
    return (React.createElement("li", { className: "c-Brands__logo" },
        React.createElement(Image, { loading: "lazy", field: props.brands.fields.brandLogo })));
};
export default BrandItem;
